class MiniCart extends HTMLElement {
  constructor() {
    super()

    this.classes = {
      openCart: 'mini-cart--shown',
      formError: 'form__input--error'
    }

    this.popup = document.querySelector('.js-menu-popup')
    this.toggles = [...document.querySelectorAll('.js-mini-cart-toggle')]
    this.forms = [...document.querySelectorAll('.js-product-form')]
    this.removeButtons = [...this.querySelectorAll('.js-mini-cart-remove')]

    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', this.onToggleClick.bind(this))
    })

    this.forms.forEach(form => {
      form.addEventListener('submit', this.onFormSubmit.bind(this))
    })

    this.removeButtons.forEach(removeButton => {
      removeButton.addEventListener('click', this.onRemoveButtonClick.bind(this))
    })

    this.checkoutCheck()
  }

  refreshMiniCart() {
    const miniCartElement = document.querySelector('.js-mini-cart-update');
    const miniCartCounter = document.querySelector('.js-mini-cart-count');

    if (miniCartElement) {
      fetch('/cart')
        .then(response => response.text())
        .then(html => {
          let currentHtml = new DOMParser().parseFromString(html, 'text/html');
          miniCartElement.innerHTML = currentHtml.querySelector('.js-mini-cart-update').innerHTML;

          this.removeButtons = [...this.querySelectorAll('.js-mini-cart-remove')]
          this.removeButtons.forEach(removeButton => {
            removeButton.addEventListener('click', this.onRemoveButtonClick.bind(this))
          })

          this.checkoutCheck()
          this.open()

          miniCartCounter.innerHTML = currentHtml.querySelector('.js-mini-cart-count').innerHTML;
        })
        .catch(error => {
          console.error('An error occurred while fetching the updated mini cart content:', error);
        });
    }
  }

  onRemoveButtonClick(e) {
    e.preventDefault()

    const params = {
      quantity: 0,
      line: e.target.dataset.id
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(params)
    };

    fetch('/cart/change.js', options)
      .then(response => response.json())
      .then(cart => {
        this.refreshMiniCart()
      })
      .catch(error => {
        console.error('An error occurred while updating the product quantity:', error);
      });
  }

  onFormSubmit(e) {
    e.preventDefault()

    let requiredFields = e.target.querySelectorAll('.js-required-field')
    let isError = false

    requiredFields.forEach(requiredField => {
      if (requiredField.classList.contains(this.classes.formError)) {
        isError = true
      }
    })

    if (isError) {
      return false
    }

    let body = JSON.stringify({
      ...JSON.parse(serializeForm(e.target)),
      properties: JSON.parse(serializeProperty(e.target))
    })

    fetch(`${routes.cart_add_url}`, {...fetchConfig('javascript'), body})
      .then((response) => response.text())
      .then((state) => {
        this.refreshMiniCart()
      })
      .catch((e) => {
        console.error(e)
      })
  }

  checkoutCheck() {
    const checkoutButton = document.querySelector(`[data-checkout]`);
    const checkoutCheckbox = document.querySelector(`[data-confirm-checkout]`);

    function checkConfirm() {
      if(!checkoutCheckbox.checked) {
        checkoutButton.setAttribute(`disabled`, `disabled`);
        return;
      }
      checkoutButton.removeAttribute(`disabled`);
    }

    checkoutCheckbox.addEventListener('change', checkConfirm);
    checkConfirm();
  }

  onToggleClick(e) {
    e.preventDefault()
    this.popup.classList.contains(this.classes.openCart) ? this.close() : this.open()
  }

  close() {
    this.popup.classList.remove(this.classes.openCart)
  }

  open() {
    this.popup.classList.add(this.classes.openCart)
  }
}

customElements.define('mini-cart', MiniCart)

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    if (!key.includes('properties'))
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

const serializeProperty = (form) => {
  const serializedData = {};
  const formData = new FormData(form);
  for (let [name, value] of formData) {
    if (name.includes('properties')) {
      name = name.replace('properties', '').replace('[', '').replace(']', '')
      serializedData[name] = value;
    }
  }
  return JSON.stringify(serializedData)
}

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  }
}
